const loginGuard = (to, from, next) => {
    if (localStorage.getItem('accessToken')) {
        next({
            path: '/dashboard',
            replace: true
        })
    } else {
        next();
    }
}

export default loginGuard